var map = {
	"./cell_1.png": [
		2873,
		873
	],
	"./cell_2.png": [
		3726,
		726
	],
	"./cell_3.png": [
		8335,
		335
	],
	"./cell_4.png": [
		8158,
		158
	],
	"./cell_5.png": [
		7565,
		565
	],
	"./cell_6.png": [
		5474,
		474
	],
	"./cell_7.png": [
		211,
		211
	],
	"./cell_8.png": [
		1436,
		436
	],
	"./cell_common.png": [
		5634,
		634
	],
	"./cell_flag.png": [
		8920,
		920
	],
	"./cell_mine.png": [
		4785,
		785
	],
	"./cell_mine_red.png": [
		5251,
		251
	],
	"./cell_not_mine.png": [
		1607,
		607
	],
	"./cell_pressed.png": [
		9265,
		265
	],
	"./cell_question.png": [
		8131,
		131
	],
	"./cell_question_pressed.png": [
		9450,
		450
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 5937;
module.exports = webpackAsyncContext;